import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppDataService {

  public appData = {['isValid']: false, ['value']: ""};

  constructor(private http: HttpClient) { }


  public getDataByEleName(ele: string) {
    let params = new HttpParams().set('ele', ele);
    return this.http.get(`/api/appdata`, {params});
  }

  setAppData(valid: boolean, value: string) {
    this.appData = {isValid: valid, value: value};
  }
}
